import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';

import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import SeoIndexAlphabetNav from '../../components/SeoDiscovery/SeoIndexAlphabetNav';
import SeoIndexPagination from '../../components/SeoDiscovery/SeoIndexPagination';
import { propTypes } from '../../util/types';
import css from '../../components/SeoDiscovery/SeoDiscovery.module.css';
import {
  VENUE_INDEX_PAGE_SIZE,
  venuesIndexPath,
  venuesLetterPath,
} from '../../util/seoDiscoveryIndexLetters';

const letterTitle = letter => (letter === '#' ? '0–9' : letter);

export const SeoDiscoveryVenuesLetterPageComponent = props => {
  const { data, fetchInProgress, fetchError } = props;
  const venues = data?.venues || [];
  const letter = data?.letter || 'A';
  const letterCounts = data?.letterCounts || {};
  const total = data?.total || 0;
  const page = data?.page || 1;
  const letterLabel = letterTitle(letter);

  return (
    <Page
      title={`Venues starting with ${letterLabel} | PromoTix`}
      description={`Browse venue guides starting with ${letterLabel}. Find tickets, seating guides, parking, and upcoming events.`}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `PromoTix Venues — ${letterLabel}`,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <p className={css.indexBreadcrumb}>
            <a href={venuesIndexPath()}>Venues</a>
            {' / '}
            {letterLabel}
          </p>
          <h1 className={css.h1}>Venues — {letterLabel}</h1>
          <p>
            Browse launched venue guides starting with {letterLabel}. Each venue page includes
            upcoming events, seating, parking, and local tips.
          </p>
          {fetchError ? <p>Unable to load venues.</p> : null}
          {fetchInProgress && !venues.length ? <p>Loading…</p> : null}
          <SeoIndexAlphabetNav
            activeLetter={letter}
            letterCounts={letterCounts}
            getLetterHref={venuesLetterPath}
          />
          <section className={css.letterSection}>
            <h2 className={css.letterHeading}>{letterLabel}</h2>
            <ul className={css.indexList}>
              {venues.map(v => (
                <li key={v.venueId}>
                  <a href={v.path}>{v.venueName}</a>
                  {v.city ? (
                    <span className={css.eventMeta}>
                      {' '}
                      — {v.city}
                      {v.state ? `, ${v.state}` : ''}
                    </span>
                  ) : null}
                </li>
              ))}
            </ul>
          </section>
          <SeoIndexPagination
            currentPage={page}
            pageSize={VENUE_INDEX_PAGE_SIZE}
            total={total}
            getPageHref={nextPage => venuesLetterPath(letter, nextPage)}
          />
          <p>
            <a href={venuesIndexPath()}>Back to all venue letters</a>
          </p>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

SeoDiscoveryVenuesLetterPageComponent.propTypes = {
  data: object,
  fetchInProgress: bool,
  fetchError: propTypes.error,
};

const mapStateToProps = state => state.SeoDiscoveryVenuesLetterPage || {};

export default connect(mapStateToProps)(SeoDiscoveryVenuesLetterPageComponent);
